// assets
import { Dashboard } from '@mui/icons-material';

// icons
const icons = {
  dashboard: Dashboard
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: 'admin/dashboard',
      icon: icons.dashboard,
      breadcrumbs: false
    }
  ]
};

export default dashboard;